import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import MedicalTeamComment from 'src/components/medical-team-comments/medical-team-comments.component'
import { PatientService } from 'src/services/patient.service'
import { useCurrentProject } from 'src/providers/current-project.provider'
import type { TMedicalTeamComment } from 'src/components/medical-team-comments/medical-team-comments.type'
import type { THumanReviewDetail } from './human-review-requests.type'

type Props = {
  humanReviewDetail: THumanReviewDetail
}

const HumanReviewPatientFooter = ({ humanReviewDetail }: Props) => {
  const { t } = useTranslation()
  const { project } = useCurrentProject()
  const queryClient = useQueryClient()
  const { patient, patientMedEvent } = humanReviewDetail

  const { data: comments = [] } = useQuery({
    queryKey: ['human-review-patient-comments', patient.id],
    queryFn: () => PatientService.getPatientComments(project.id, patient.id),
  })

  const onUpdateMedicalTeamComment = (patientId: number, updatedComments: TMedicalTeamComment[]) => {
    queryClient.setQueryData(['human-review-patient-comments', patientId], updatedComments)
  }

  return (
    <div className="c-flex c-flex-col c-pl-4 c-pt-4 c-pb-10 c-text-sm">
      <h2 className="c-text-base c-font-bold c-tracking-wider c-mb-2">
        {t('components.medical-team-comments.title')}
      </h2>
      <MedicalTeamComment
        patientId={patient.id}
        medicalTeamComments={comments}
        onUpdateMedicalTeamComment={onUpdateMedicalTeamComment}
        patientMedEventId={patientMedEvent.id}
      />
    </div>
  )
}

export default HumanReviewPatientFooter
